import { TProductPremiumSingleBlockWitParsedImage } from '@features/cms/typescript/index';
import useProductPremiumSlide from '@hooks/useProductPremiumSlide';
import ProductPremiumProductDescription from '@features/cms/components/collections/ProductPremiumBlock/components/ProductPremiumProductDescription/ProductPremiumProductDescription';
import ProductPremiumArrangement from '@features/cms/components/collections/ProductPremiumBlock/components/ProductPremiumArrangement/ProductPremiumArrangement';
import ProductPremiumDescription from '@features/cms/components/collections/ProductPremiumBlock/components/ProductPremiumDescription/ProductPremiumDescription';
type PropsType = {
  blocks: TProductPremiumSingleBlockWitParsedImage[];
  activeBlock: number;
  viewportHeight: number;
  viewportWidth: number;
  isFirst: boolean;
  isStackedMobile?: boolean;
};
const ProductPremiumSlide = ({
  blocks,
  activeBlock,
  viewportHeight,
  viewportWidth,
  isFirst,
  isStackedMobile = false
}: PropsType) => {
  const {
    currentBlock,
    isProductDescriptionVariant,
    isArrangementVariant,
    isDescriptionVariant
  } = useProductPremiumSlide(blocks, activeBlock);
  return <>
      {isProductDescriptionVariant(currentBlock) && <ProductPremiumProductDescription viewportHeight={viewportHeight} viewportWidth={viewportWidth} blocks={blocks} activeBlock={activeBlock} isFirst={isFirst} isStackedMobile={isStackedMobile} />}
      {isArrangementVariant(currentBlock) && <ProductPremiumArrangement viewportHeight={viewportHeight} viewportWidth={viewportWidth} blocks={blocks} activeBlock={activeBlock} isFirst={isFirst} isStackedMobile={isStackedMobile} />}
      {isDescriptionVariant(currentBlock) && <ProductPremiumDescription viewportHeight={viewportHeight} viewportWidth={viewportWidth} blocks={blocks} activeBlock={activeBlock} isFirst={isFirst} isStackedMobile={isStackedMobile} />}
    </>;
};
export default ProductPremiumSlide;